"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _css = require("@emotion/css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tag = _interopRequireDefault(require("@amzn/meridian-tokens/component/tag"));
var _theme = require("../theme");
/**
 * Styles
 */

var styles = function styles(t, _ref) {
  var type = _ref.type,
    compact = _ref.compact;
  return (0, _css.css)({
    display: "inline-block",
    width: t("indicatorDiameter"),
    height: t("indicatorDiameter"),
    backgroundColor: t("borderColorStatus", type),
    borderRadius: t("indicatorDiameter") / 2,
    marginInlineEnd: compact ? 0 : t("spacingHorizontal"),
    flexShrink: 0
  });
};

/**
 * Component
 */

function Indicator(props) {
  var t = (0, _theme.useTheme)(_tag["default"], "tag");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props)
  });
}
Indicator.propTypes = process.env.NODE_ENV !== "production" ? {
  compact: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(["success", "warning", "error", "theme", "neutral"])
} : {};
Indicator.defaultProps = {
  type: "theme"
};
var _default = Indicator;
exports["default"] = _default;